var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnQ18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.25,
    height: 64.5,
    viewBox: "0 0 80.25 64.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(0 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 1.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M0,61.023v-39.1L25.934,0,37.6,9.866V6.943h6.051v8.039l8.213,6.943v39.1Z",
    fill: "#e1f4fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(3.963 4.999)",
    fill: "#e1f4fb",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.18289947509766 51.87885665893555 L 0.7499997615814209 51.87885665893555 L 0.7499997615814209 18.67136764526367 L 21.97076797485352 0.9766046404838562 L 43.18289947509766 18.67128753662109 L 43.18289947509766 51.87885665893555 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.97067451477051 1.953205108642578 L 1.5 19.02249908447266 L 1.5 51.12885665893555 L 42.43289947509766 51.12885665893555 L 42.43289947509766 19.02231979370117 L 21.97067451477051 1.953205108642578 M 21.97086906433105 -3.814697265625e-06 L 43.93289947509766 18.32021713256836 L 43.93289947509766 52.62885665893555 L 0 52.62885665893555 L 0 18.32021713256836 L 21.97086906433105 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 3.972,
    height: 14.884,
    transform: "translate(47.896 29.023)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 10.549,
    height: 18.605,
    transform: "translate(69.451)",
    fill: "#fff",
    stroke: "#e1f4fb",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 10.549,
    height: 18.605,
    transform: "translate(69.451 45.395)",
    fill: "#fff",
    stroke: "#e1f4fb",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    "data-name": "Rectangle",
    width: 10.549,
    height: 26.791,
    transform: "translate(69.451 18.605)",
    fill: "#fff",
    stroke: "#e1f4fb",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    opacity: 0.733
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M.5.486V25.809",
    transform: "translate(71.225 18.852)",
    fill: "none",
    stroke: "#00a3da",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2-2",
    "data-name": "Line 2",
    d: "M.5.486V25.809",
    transform: "translate(74.226 18.852)",
    fill: "none",
    stroke: "#00a3da",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2-3",
    "data-name": "Line 2",
    d: "M.5.486V25.809",
    transform: "translate(77.226 18.852)",
    fill: "none",
    stroke: "#00a3da",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnQ18);
export default __webpack_public_path__ + "static/media/on_Q1_8_.412759a4a03a65dc803e8620df1e35ef.svg";
export { ForwardRef as ReactComponent };